module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIj48cGF0aCBmaWxsPSIjM2E3NWM0IiBkPSJNMCAwaDQwMHYzMDBIMHoiLz48cGF0aCBmaWxsPSIjZmNkMTE2IiBkPSJNMCAwaDQwMHYyMDBIMHoiLz48cGF0aCBmaWxsPSIjMDA5ZTYwIiBkPSJNMCAwaDQwMHYxMDBIMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/gab.svg
// module id = BbhZ
// module chunks = 0